export enum AuthResult {
  INVALID = "Invalid",
  OK = "Ok",
  LOCKED = "Locked",
  PASSWORD_EXPIRED = "PasswordExpired",
}
